<template>
  <div class="error-page-wrapper">
    <div
      class="p-4 md:p-8 flex items-center justify-center relative overflow-hidden"
    >
      <div class="w-full max-w-2xl relative mx-auto my-8">
        <div
          class="bg-white/[0.02] backdrop-blur-xl rounded-3xl p-8 md:p-12 shadow-[0_8px_32px_rgba(0,0,0,0.2)] border border-white/10 hover:border-white/20 transition-all duration-500 text-center"
        >
          <svg
            class="w-12 h-12 text-red-500 mx-auto mb-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>

          <h1 class="text-2xl font-bold text-white mb-3">
            Notificación del Sistema
          </h1>
          <p class="text-white/80 text-base mb-2">
            No se pudo procesar su solicitud de soporte.
          </p>
          <p class="text-white/60">Por favor, intente enviar nuevamente.</p>

          <router-link
            to="/"
            class="inline-block mt-6 px-6 py-3 bg-[#3587F2] text-white rounded-lg hover:bg-[#2776E8] transition-colors duration-300"
          >
            Volver al Formulario
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.error-page-wrapper {
  min-height: calc(100vh - 400px);
  position: relative;
  display: flex;
  flex-direction: column;
}

:deep(.footer) {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
}
</style>

<script>
export default {
  name: 'ErrorPage',
}
</script>
